import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CharacterChoiceComponent } from '../character-choice/character-choice.component';
import { SvgIconComponent } from 'component-library';

@Component({
  selector: 'app-intro-screen',
  standalone: true,
  imports: [CharacterChoiceComponent, SvgIconComponent],
  templateUrl: './intro-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './intro-screen.component.scss',
})
export class IntroScreenComponent {
  readonly backgroundPath = input<string>();

  readonly fieldClicked = output<string>();
  readonly pageBack = output<boolean>();

  characters: { label: string; introImage: string }[] = [
    {
      label: 'Officier zeedienst',
      introImage: 'assets/images/officier-zeedienst.png',
    },
    {
      label: 'Officier der mariniers',
      introImage: 'assets/images/officier-der-mariniers.png',
    },
    {
      label: 'Officier techniek',
      introImage: 'assets/images/officier-techniek.png',
    },
    {
      label: 'Officier logistiek',
      introImage: 'assets/images/officier-logistiek.png',
    },
  ];

  onFieldClicked(field: string) {
    this.fieldClicked.emit(field);
  }

  onBackClicked(): void {
    this.pageBack.emit(true);
  }
}
